module.exports = __webpack_public_path__ + "img/sac-object-single.e60b9a11.jpg";